import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

/** Принудительно включает функционал, доступный после связки аккаунтов */
export const forceVigboLinkedAccont: boolean = isFeature('force-vigbo-linked-account');

/** Список тарифов, для которых доступна интеграция с Vigbo */
export const vigboTariffs: string[] = getFeature('vigbo-tariffs') || [];
